/**
 * Stripe Connect embedded component collection options.
 *
 * Set as client-side props on ConnectAccountOnboarding and ConnectNotificationBanner.
 * The server-side AccountSession does NOT set collection_options. If server-side
 * config is ever added, it takes precedence — keep both in sync.
 *
 * Activation: show only what Stripe requires right now (clean onboarding UX).
 * Dashboard banner: surface future requirements so the org sees upcoming EIN/
 * verification work before it becomes urgent.
 */
export const STRIPE_ACTIVATION_COLLECTION_OPTIONS = {
  fields: 'currently_due',
  futureRequirements: 'omit',
};

export const STRIPE_DASHBOARD_NOTIFICATION_COLLECTION_OPTIONS = {
  fields: 'currently_due',
  futureRequirements: 'include',
};
